/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import i18n from 'i18n';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import { cyrb53Hash } from 'utils/helpers';
import {
  setSelectedEnvironment,
  getAllEnvironmentsRequest,
} from 'modules/environments/actions';

import clsx from 'clsx';
import {
  EnvironmentFields,
  ListEnvironmentDataProps,
} from 'modules/environments/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import { SearchBar } from 'components/SearchBar';
import { EnvironmentFieldsProps } from '.';
import styles from './styles';

const initialQuery = {
  offset: 0,
  limit: 10,
  search: '',
};

interface Props {
  isLoading: boolean;
  companyFields: EnvironmentFieldsProps | null;
  environmentList: ListEnvironmentDataProps;
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  setCompanyFields: (prop: EnvironmentFieldsProps | null) => void;
  getAllEnvironmentsRequest: (props) => void;
  setSelectedEnvironment: (prop: EnvironmentFields | null) => void;
  setOpenEnvironmentSelector: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenClientSelector: React.Dispatch<React.SetStateAction<boolean>>;
}

const EnvironmentList = ({
  isLoading,
  companyFields,
  environmentList,
  companySelected,
  partnerSelected,
  getAllEnvironmentsRequest,
  setCompanyFields,
  setSelectedEnvironment,
  setOpenEnvironmentSelector,
  setOpenClientSelector,
}: Props) => {
  const headers = [
    {
      key: 'name',
      i18n: 'ENVIRONMENT_NAME_KEY',
      order: true,
    },
  ];

  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    query,
    searchValue,
    itemOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
    handleOrder,
  } = useTableFilters(initialQuery);

  const getEnvironments = () => {
    getAllEnvironmentsRequest({
      ...query,
      company_uuid: companySelected?.id,
      partner_uuid: partnerSelected?.id,
    });
  };

  React.useEffect(() => {
    getEnvironments();
  }, [getAllEnvironmentsRequest, query, companySelected, partnerSelected]);

  return (
    <Grid container>
      <SearchBar
        id="search-environments"
        isLoading={isLoading}
        searchValue={searchValue}
        handleSearch={handleSearch}
        setSearchValue={setSearchValue}
      />
      <TableItems
        header={
          <>
            {headers.map(item => (
              <TableCell
                key={item?.key}
                order={item?.order}
                handleOrder={() =>
                  item?.order ? handleOrder(item?.key) : null
                }
                markOderItem={itemOrder === item?.key}
              >
                {i18n.t(item?.i18n)}
              </TableCell>
            ))}
          </>
        }
        renderItems={(item: EnvironmentFields, index) => (
          <TableRow
            key={cyrb53Hash(index)}
            onClick={() => {
              setCompanyFields({
                environment_name: item?.name,
                environment_id: item?.environment_uuid,
              });
              setSelectedEnvironment(item);
              setOpenEnvironmentSelector(false);
              setOpenClientSelector(true);
            }}
            className={clsx(classes.tableRow, {
              [classes.itemSelected]:
                companyFields?.environment_id === item?.environment_uuid,
            })}
          >
            <TableCell className={classes.companyCell}>
              <Tooltip title={item?.name} arrow>
                <Typography className={classes.name}>{item?.name}</Typography>
              </Tooltip>
            </TableCell>
          </TableRow>
        )}
        overrideRowsCount={10}
        data={environmentList}
        isLoading={isLoading}
        onChangePage={handlePageChange}
        onChangeLimit={handleLimitChange}
        notFoundText={
          <Typography>{i18n.t('MONITOR.NO_RESULTS_INSTANCES')}</Typography>
        }
      />
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentList, isLoading },
  authenticate: { companySelected, partnerSelected },
}: ApplicationState) => ({
  isLoading,
  environmentList,
  companySelected,
  partnerSelected,
});

export default connect(mapStateToProps, {
  getAllEnvironmentsRequest,
  setSelectedEnvironment,
})(EnvironmentList);
